export const CURRENCY_CODE = {
  IDR: "IDR",
  SGD: "SGD",
  USD: "USD",
  PHP: "PHP",
};
